const rtlLanguages = new Set([
  'ar',
  'ckb',
  'dv',
  'fa',
  'he',
  'ku',
  'ps',
  'sd',
  'ug',
  'ur',
  'yi',
]);

export function getTextDirection(localeCode: string): 'rtl' | 'ltr' {
  const baseLanguage = localeCode.toLowerCase().split(/[-_]/)[0];
  return rtlLanguages.has(baseLanguage) ? 'rtl' : 'ltr';
}
